import Slider from 'react-slick';
import SectionTitle from "../SectionTitle/SectionTitle";
import ProjectCard from './ProjectCard';
import Projects from "../../api/projects";





const ProjectSection = (props) => {



    const settings = {
        centerMode: false,
        infinite: false,
        centerPadding: '0px',
        speed: 500,
        dots: true,
        arrows: false,
        variableWidth: false,
        slidesToShow: 2,
        responsive: [{
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                variableWidth: false,
                centerMode: false,
            }
        }]
    };

 
    return (
       
        <section className={"section-padding " + props.hclass}>
       
            <div >
                <div className="row justify-content-center">
                    <div className="col-12">
                        <SectionTitle subtitle="Empower and Grow" title="Build the Future With Us." />
                    </div>
                </div>
            </div>
            <div className="project-slider" >
                <Slider {...settings}>
                    {Projects.map((item, Pindx) => (
                        <div key={Pindx}>
                            <ProjectCard Pimg={item.pimg1} Psubtitle={item.subtitle} Ptitle={item.title} Pslug={item.slug} />
                        </div>
                    ))}
                </Slider>

            </div>
            
        </section>
       
    )
}

export default ProjectSection;











